// extracted by mini-css-extract-plugin
export default {"second":"Second_second__tfImy","second__header":"Second_second__header__eMS2r","second__title":"Second_second__title__Xg5E8"};